export const ENV_LOCAL = "LOCAL";
export const ENV_DEV = "DEV";
export const ENV_RC = "RC";
export const ENV_STG = "STAGING";
export const ENV_PROD = "PRODUCTION";
